import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  summaryRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  totalRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing[4],
  },
  summaryValue: {
    textAlign: 'right',
  },
  updatingAmount: {
    opacity: 0.4,
  },
  bottomSheet: {
    backgroundColor: colors.backgroundL0,
  },
  summaryTitleRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  promoButton: {
    padding: 0,
    height: 'auto',
  },
  tooltipIconContainer: {
    width: 18,
    height: 18,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.borderRadius.full,
    backgroundColor: colors.backgroundL1,
  },
}));
